(function () {
  'use strict';

  var STORAGE_KEY = 'yd_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, fail silently */
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function updateButtonState(button) {
    var handle = button.getAttribute('data-wishlist-handle');
    var active = isInWishlist(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? 'Remove from wishlist' : 'Add to wishlist';
    button.setAttribute('aria-label', label);
    button.title = label;
  }

  function updateAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      updateButtonState(buttons[i]);
    }
    updateHeaderCount();
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].hidden = count === 0;
    }
  }

  // --- Push an event to Klaviyo whenever an item is added, so a flow can be
  // built off it. Klaviyo has shipped a couple of different JS APIs over the
  // years depending on when/how a store integrated, so we try each one that
  // might exist rather than assuming a single global shape:
  //   1. window.klaviyo.track(event, properties)      -- current Proxy-based API
  //   2. window.klaviyo.push(['track', event, props])  -- array-style, still supported
  //   3. window._learnq.push(['track', event, props])  -- legacy global name
  // We also log to the console when none of these exist, so this is easy to
  // diagnose from the browser console rather than failing completely silently.
  function trackWishlistEvent(eventName, button) {
    var properties = {
      ProductName: button.getAttribute('data-wishlist-title') || '',
      Handle: button.getAttribute('data-wishlist-handle') || '',
      URL: button.getAttribute('data-wishlist-url') || '',
      ImageURL: button.getAttribute('data-wishlist-image') || '',
      Price: button.getAttribute('data-wishlist-price') || '',
      Currency: button.getAttribute('data-wishlist-currency') || ''
    };

    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, properties);
        return;
      }
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', eventName, properties]);
        return;
      }
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['track', eventName, properties]);
        return;
      }
      if (window.console && window.console.warn) {
        window.console.warn('[wishlist] Klaviyo not found on window (checked klaviyo.track, klaviyo.push, _learnq.push) — event "' + eventName + '" was not sent.');
      }
    } catch (e) {
      if (window.console && window.console.warn) {
        window.console.warn('[wishlist] Klaviyo tracking threw an error:', e);
      }
    }
  }

  // --- Lightweight toast notification, self-contained (inline styles) so it
  // works on any page regardless of which stylesheets are loaded there.
  var toastEl = null;
  var toastTimer = null;

  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.id = 'yd-wishlist-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:24px',
      'transform:translateX(-50%) translateY(16px)',
      'background:#000',
      'color:#fff',
      'padding:10px 18px',
      'border-radius:999px',
      'font-size:13px',
      'font-family:sans-serif',
      'letter-spacing:.02em',
      'z-index:99999',
      'opacity:0',
      'pointer-events:none',
      'transition:opacity .25s ease, transform .25s ease',
      'box-shadow:0 4px 16px rgba(0,0,0,.25)',
      'white-space:nowrap'
    ].join(';');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showToast(message) {
    var toast = ensureToast();
    toast.textContent = message;
    void toast.offsetWidth;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(16px)';
    }, 2200);
  }

  function onClick(e) {
    var button = e.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = button.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var nowActive = toggleWishlist(handle);
    updateButtonState(button);
    var others = document.querySelectorAll('[data-wishlist-toggle][data-wishlist-handle="' + handle + '"]');
    for (var i = 0; i < others.length; i++) {
      updateButtonState(others[i]);
    }
    updateHeaderCount();
    showToast(nowActive ? 'Added to wishlist' : 'Removed from wishlist');
    if (nowActive) {
      trackWishlistEvent('Added to Wishlist', button);
    } else {
      trackWishlistEvent('Removed from Wishlist', button);
    }
  }

  document.addEventListener('click', onClick);

  // --- Keep the header badge (and button states) correct even when the theme
  // swaps sections of the page in via AJAX/view-transitions instead of a full
  // reload (e.g. Shopify's page-transition / section-morphing navigation).
  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) return;
    refreshTimer = window.requestAnimationFrame(function () {
      refreshTimer = null;
      updateAllButtons();
    });
  }

  function containsWishlistNode(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && (node.matches('[data-wishlist-toggle]') || node.matches('[data-wishlist-count]'))) {
      return true;
    }
    if (node.querySelector && node.querySelector('[data-wishlist-toggle], [data-wishlist-count]')) {
      return true;
    }
    return false;
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (containsWishlistNode(added[j])) {
          scheduleRefresh();
          return;
        }
      }
    }
  });

  function startObserving() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', updateAllButtons);
  window.addEventListener('pageshow', updateAllButtons);
  document.addEventListener('shopify:section:load', updateAllButtons);

  if (document.readyState !== 'loading') {
    updateAllButtons();
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }

  window.YDWishlist = {
    get: getWishlist,
    has: isInWishlist,
    toggle: toggleWishlist,
    refresh: updateAllButtons,
    toast: showToast,
    trackTest: trackWishlistEvent,
  };
})();
